enum AnswerPresentationType {
  Radio,
  Text,
  DatePicker
}

export default AnswerPresentationType;
